const MainDetailsCellRenderer = (params: any) => {
  const data = params.data;
  const cryptoID = params.colDef.cellRendererParams.cryptoID;
  let returnJSX = (
    <div className="overflow-hidden text-ellipsis">{data.details}</div>
  );

  if (data) {
    if (data != undefined && cryptoID != undefined) {
      returnJSX = (
        // <Draggable
        //   id={data.esid + cryptoID + "Details"}
        //   value={data.details}
        //   header={"Details"}
        // >
        <div className="overflow-hidden text-ellipsis">{data.details}</div>
        // </Draggable>
      );
    }
  }

  return (
    <div>
      <div>{returnJSX}</div>
    </div>
  );
};
export default MainDetailsCellRenderer;
